import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { SequenceStore } from '../sequence.store';
import { DateTime } from 'luxon';
import { Observable, Subject, takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DecsStore } from '@shared/services/decs/decs.store';
import { DutyInfoDialogComponent } from './duty-info-dialog/duty-info-dialog.component';
import { PayInfoDialogComponent } from './pay-info-dialog/pay-info-dialog.component';
import { SeqTotalDialogComponent } from './seq-total-dialog/seq-total-dialog.component';
import { SequenceView } from '../models/view/sequence.view';
import { RouteParameterStore } from '@shared/services/route-parameter.store';
import { RequestState } from '@shared/models/request-state';
import { SabreTextDialogComponent } from '@shared/components/sabre-text-dialog/sabre-text-dialog.component';
import { HotelDialogComponent } from '@shared/features/hotel/hotel-dialog/hotel-dialog.component';

@Component({
  selector: 'app-sequence-card',
  templateUrl: './sequence-card.component.html',
  styleUrls: ['./sequence-card.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SequenceCardComponent implements OnInit, OnDestroy {
  sequenceState$?: Observable<RequestState<SequenceView | null>>;
  destroy$ = new Subject<void>();
  // hotelRequest: HotelRequest | null = null;

  // Used to keep track of which expansion panels are expanded when returning back to the sequence display.
  // The CustomReuseStrategy reuses SequenceCardComponents, so this state is preserved
  // after navigating away (for example to leg details) then back.
  dutyPeriodExpansionState: { [key: number]: boolean } = {};

  // For referencing in data boxes.
  dutyInfoDialogComponent = DutyInfoDialogComponent;
  payInfoDialogComponent = PayInfoDialogComponent;
  seqTotalDialogComponent = SeqTotalDialogComponent;

  // This variable is used to keep expansion panels from reacting when a button within the header is clicked.
  buttonClicked = false;

  DateTime = DateTime; // Required so template can access DateTime format helpers.

  constructor(
    private sequenceStore: SequenceStore,
    private decsStore: DecsStore,
    private routeParamStore: RouteParameterStore,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.routeParamStore.sequenceParams$
      .pipe(takeUntil(this.destroy$))
      .subscribe((seqParams) => {
        // Set sequence observable based on route parameters.
        this.sequenceState$ = this.sequenceStore.getSequence({
          number: seqParams?.number || '',
          seat: seqParams?.seat || '',
          date: seqParams?.date || '',
        });
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  /** Open hotel info dialog. */
  onLayoverClick(dutyPeriodIndex: number, sequence: SequenceView): void {
    this.buttonClicked = true;

    this.dialog.open(HotelDialogComponent, {
      data: {
        dutyPeriodIndex,
        sequence,
      },
      maxHeight: '95vh',
      maxWidth: '100vw',
    });
  }

  onDutyPeriodExpanded(dutyPeriod: number): void {
    this.dutyPeriodExpansionState[dutyPeriod] = true;
  }

  onDutyPeriodClosed(dutyPeriod: number): void {
    this.dutyPeriodExpansionState[dutyPeriod] = false;
  }

  onSeqTextClick(): void {
    const sabreCmd = this.sequenceStore.getSeqSabreCmd();

    this.dialog.open(SabreTextDialogComponent, {
      data: {
        sabreText$: this.decsStore.submitDecsRequest(sabreCmd, false),
        refreshFn: this.decsStore.refreshFn,
        request: sabreCmd,
      },
      panelClass: 'sabre-text',
      maxHeight: '95vh',
      maxWidth: '100vw',
    });
  }

  onRefreshClick(): void {
    this.sequenceState$ = this.sequenceStore.refreshSequence();
  }
}
